export default {
  "components": {
    "dates": {
      "sun": {
        "default": "Sunday",
        "value": "Neděle"
      },
      "mon": {
        "default": "Monday",
        "value": "Pondělí"
      },
      "tue": {
        "default": "Tuesday",
        "value": "Úterý"
      },
      "wed": {
        "default": "Wednesday",
        "value": "Středa"
      },
      "thu": {
        "default": "Thursday",
        "value": "Čtvrtek"
      },
      "fri": {
        "default": "Friday",
        "value": "Pátek"
      },
      "sat": {
        "default": "Saturday",
        "value": "Sobota"
      },
      "suns": {
        "default": "Sun",
        "value": "Ne"
      },
      "mons": {
        "default": "Mon",
        "value": "Po"
      },
      "tues": {
        "default": "Tue",
        "value": "Út"
      },
      "weds": {
        "default": "Wed",
        "value": "St"
      },
      "thus": {
        "default": "Thu",
        "value": "Čt"
      },
      "fris": {
        "default": "Fri",
        "value": "Pá"
      },
      "sats": {
        "default": "Sat",
        "value": "So"
      },
      "jan": {
        "default": "January",
        "value": "leden"
      },
      "feb": {
        "default": "February",
        "value": "únor"
      },
      "mar": {
        "default": "March",
        "value": "březen"
      },
      "apr": {
        "default": "April",
        "value": "duben"
      },
      "may": {
        "default": "May",
        "value": "květen"
      },
      "jun": {
        "default": "June",
        "value": "červen"
      },
      "jul": {
        "default": "July",
        "value": "červenec"
      },
      "aug": {
        "default": "August",
        "value": "srpen"
      },
      "sep": {
        "default": "September",
        "value": "září"
      },
      "oct": {
        "default": "October",
        "value": "říjen"
      },
      "nov": {
        "default": "November",
        "value": "listopad"
      },
      "dec": {
        "default": "December",
        "value": "prosinec"
      },
      "jans": {
        "default": "Jan",
        "value": "led"
      },
      "febs": {
        "default": "Feb",
        "value": "úno"
      },
      "mars": {
        "default": "Mar",
        "value": "bře"
      },
      "aprs": {
        "default": "Apr",
        "value": "dub"
      },
      "mays": {
        "default": "May",
        "value": "kvě"
      },
      "juns": {
        "default": "Jun",
        "value": "čvn"
      },
      "juls": {
        "default": "Jul",
        "value": "čvc"
      },
      "augs": {
        "default": "Aug",
        "value": "srp"
      },
      "seps": {
        "default": "Sep",
        "value": "zář"
      },
      "octs": {
        "default": "Oct",
        "value": "říj"
      },
      "novs": {
        "default": "Nov",
        "value": "lis"
      },
      "decs": {
        "default": "Dec",
        "value": "pro"
      }
    },
    "commonPersonalData": {
      "errInvalidFields": {
        "default": "Invalid form fields.",
        "value": "Neplatná formulářová pole"
      },
      "personalDataSaved": {
        "default": "Your data has been saved.",
        "value": "Vaše data byla uložena."
      }
    },
    "validations": {
      "cannotBeEmpty": {
        "default": "This field cannot be empty.",
        "value": "Toto pole je povinné."
      },
      "notAnEmail": {
        "default": "Provided value is not a valid email address.",
        "value": "Toto není platná emailová adresa."
      },
      "passwordLength": {
        "default": "The password must be minimum ${charNo} characters with at least one lowercase character and one special character.",
        "value": "Heslo musí mít minimálně ${charNo} znaků s alespoň jedním malým písmenem a jedním speciálním znakem."
      }
    },
    "bwReceipt": {
      "barOffer": {
        "default": "Offer",
        "value": "Nabídka"
      },
      "barExtras": {
        "default": "Extras",
        "value": "Extra položky"
      },
      "barMietbetrag": {
        "default": "Rental fee",
        "value": "Poplatek za pronájem"
      },
      "recOffer": {
        "default": "Offer",
        "value": "Nabídka"
      },
      "recServices": {
        "default": "Services",
        "value": "Služby"
      },
      "recDiscount": {
        "default": "Discount",
        "value": "Sleva"
      },
      "recAccessories": {
        "default": "Accessories",
        "value": "Příslušenství"
      },
      "recDeposit": {
        "default": "Kaution",
        "value": "Kauce"
      },
      "bookedFrom": {
        "default": "Booking from",
        "value": "Objednávka od"
      },
      "bookedTo": {
        "default": "to",
        "value": "do"
      },
      "totalDiscount": {
        "default": "Total Discount",
        "value": "Celková sleva"
      },
      "totalSurcharge": {
        "default": "Total Surcharge",
        "value": "Celkový příplatek"
      },             
      "vatIncluded": {
        "default": "All prices are including VAT.",
        "value": "Všechny ceny zahrnují DPH."
      }            
    },
    "bwStepBar": {
      "bookingDates": {
        "default": "Bookingdates",
        "value": "Termín objednávky"
      },
      "services": {
        "default": "Services",
        "value": "Služby"
      },
      "accessories": {
        "default": "Accessories",
        "value": "Příslušenství"
      },
      "personalData": {
        "default": "Contact data",
        "value": "Kontakt"
      },
      "review": {
        "default": "Review",
        "value": "Shrnutí"
      },
      "payment": {
        "default": "Payment",
        "value": "Platba"
      }
    },
    "siteHeader": {
      "passwordRecovery": {
        "default": "Passwort vergessen?",
        "value": "Zapomenuté heslo?"
      },      
      "login": {
        "default": "Login",
        "value": "Přihlášení"
      },
      "userName": {
        "default": "Username",
        "value": "Uživatelské Jméno"
      },
      "password": {
        "default": "Password",
        "value": "Heslo"
      },
      "performLogin": {
        "default": "Login",
        "value": "Přihlášení"
      },
      "newRegistration": {
        "default": "Sign up",
        "value": "Zaregistrovat"
      },
      "userProfile": {
        "default": "My profile",
        "value": "Můj profil"
      },
      "userBookings": {
        "default": "My bookings",
        "value": "Moje objednávky"
      },
      "performLogout": {
        "default": "Log out",
        "value": "Odhlášení"
      }
    },
    "siteFooter": {
      "claimText1": {
        "default": "Das umfassende",
        "value": "Komplexní"        
      },
      "claimText2": {
        "default": "Reservationssystem",
        "value": "rezervační systém"   
      },  
      "claimText3": {
        "default": "für Sie",
        "value": "pro Vás"
      }          
    }    
  },
  "pages": {
    "bw03Accessories": {
      "back": {
        "default": "Back",
        "value": "Zpět"
      },
      "accessories": {
        "default": "Accessories",
        "value": "Příslušenství"
      },
      "next": {
        "default": "Next",
        "value": "Dále"
      }
    },
    "bw07BookingFinished": {
      "confirmation": {
        "default": "Confirmation",
        "value": "Potvrzení"
      },
      "bookingFor": {
        "default": "The booking for",
        "value": "Objednávka"
      },
      "fromDate": {
        "default": "from",
        "value": "od"
      },
      "toDate": {
        "default": "to",
        "value": "do"
      },
      "forPrice": {
        "default": "for",
        "value": "za"
      },
      "wasFinished": {
        "default": "was successfully completed.",
        "value": "byla úspěšně dokončena."
      },
      "bookingDetailsSent": {
        "default": "The booking details and invoice have been sent to your e-mail address.",
        "value": "Detail objednávky a faktura byly zaslány na Vaši emailovou adresu."
      },
      "performRegister": {
        "default": "Sign up",
        "value": "Zaregistrovat"
      },
      "performPrint": {
        "default": "Print confirmation",
        "value": "Tisk potvrzení"
      },
      "goHome": {
        "default": "Go to homepage ",
        "value": "Zpět na úvodní stránku"
      }
    },
    "bw01OfferDetails": {
      "next": {
        "default": "Next",
        "value": "Dále"
      },
      "bookingDates": {
        "default": "Booking data",
        "value": "Termín objednávky"
      },
      "instructionsTitle1": {
        "default": "Instructions",
        "value": "Návod"
      },
      "instructionsText1": {
        "default": "Passen Sie bei Bedarf die Start- und Endzeiten an. Beachten Sie, dass das System Ihre Angaben automatisch korrigieren kann um die Buchungsregeln des Vermieters zu berücksichtigen.",
        "value": "Podle potřeby upravte čas zahájení a ukončení. Systém může Vaše zadání automaticky upravit tak, aby splňovalo objednací podmínky pronajímatele."
      },      
      "startDate": {
        "default": "Start time",
        "value": "Začátek"
      },
      "endDate": {
        "default": "End time",
        "value": "Konec"
      },
      "applyNewValues": {
        "default": "Show",
        "value": "Zobrazit"
      },
      "weekView": {
        "default": "Week view",
        "value": "Týdenní náhled"
      },
      "monthView": {
        "default": "Month view",
        "value": "Měsíční náhled"
      },
      "yourChoice": {
        "default": "Your selection",
        "value": "Váš výběr"
      },
      "instructionsTitle2": {
        "default": "Instructions",
        "value": "Návod"
      },
      "yourBooking": {
        "default": "Your reservation",
        "value": "Vaše rezervace"
      },
      "notAvailable": {
        "default": "Not available",
        "value": "Není k dispozici"
      },
      "pickupDrop": {
        "default": "Pickup and return times",
        "value": "Čas převzetí a vrácení"
      },
      "back": {
        "default": "Back",
        "value": "Zpět"
      }
    },
    "bw06Payment": {
      "payment": {
        "default": "Payment",
        "value": "Platba"
      },
      "bankAccount": {
        "default": "Banking details",
        "value": "Bankovní spojení"
      },
      "bankPaymentConditions": {
        "default": "Payment conditions",
        "value": "Platební podmínky"
      },
      "back": {
        "default": "Back",
        "value": "Zpět"
      },
      "firmlyBookFor": {
        "default": "Book bindingly for",
        "value": "Závazně objednat za"
      }
    },
    "bw04PersonalData": {
      "street": {
        "default": "Street, Nr. *",
        "value": "Ulice, č. *"
      },
      "addressAddition": {
        "default": "Address suffix",
        "value": "Doplnění adresy"
      },
      "postNumber": {
        "default": "ZIP *",
        "value": "PSČ *"
      },
      "place": {
        "default": "Place *",
        "value": "Obec *"
      },
      "country": {
        "default": "Country *",
        "value": "Stát *"
      },
      "back": {
        "default": "Back",
        "value": "Zpět"
      },
      "personalData": {
        "default": "Contact details",
        "value": "Kontakt"
      },
      "pleaseLogin": {
        "default": "Please log in",
        "value": "Přihlašte se"
      },
      "userName": {
        "default": "User name",
        "value": "Uživatelské jméno"
      },
      "password": {
        "default": "Password",
        "value": "Heslo"
      },
      "loginAsGuest": {
        "default": "Book as guest",
        "value": "Objednat jako host"
      },
      "login": {
        "default": "Log in",
        "value": "Přihlášení"
      },
      "customerInformation": {
        "default": "Customer information",
        "value": "Informace o zákazníkovi"
      },
      "salutation": {
        "default": "Salutation *",
        "value": "Oslovení *"
      },
      "firstName": {
        "default": "First name *",
        "value": "Křestní jméno *"
      },
      "lastName": {
        "default": "Family Name *",
        "value": "Příjmení *"
      },
      "organization": {
        "default": "Organization",
        "value": "Organizace"
      },       
      "email": {
        "default": "Email *",
        "value": "Email *"
      },
      "phone": {
        "default": "Phone",
        "value": "Telefon"
      },
      "mobilePhone": {
        "default": "Cellphone *",
        "value": "Mobilní telefon *"
      },      
      "address": {
        "default": "Address",
        "value": "Adresa"
      },
      "useDifferentBillingAddress": {
        "default": "Use different address for billing.",
        "value": "Odlišná fakturační adresa"
      },
      "cancelGuestLogin": {
        "default": "Cancel guest booking",
        "value": "Zrušit objednávku jako host"
      },
      "next": {
        "default": "Next",
        "value": "Dále"
      }
    },
    "bw05Review": {
      "discount": {
        "default": "Disount",
        "value": "Sleva"
      },
      "totalDiscount": {
        "default": "Total Discount",
        "value": "Celková sleva"
      }, 
      "totalSurcharge": {
        "default": "Total Surcharge",
        "value": "Celkový příplatek"
      },               
      "offer": {
        "default": "Angebot",
        "value": "Nabídka"
      },  
      "services": {
        "default": "Dienstleistungen",
        "value": "Služby"
      },     
      "accessories": {
        "default": "Zubehör",
        "value": "Příslušenství"
      },           
      "deposit": {
        "default": "Kaution",
        "value": "Kauce"
      },      
      "review": {
        "default": "Review",
        "value": "Shrnutí"
      },
      "mietbetrag": {
        "default": "Rental fee",
        "value": "Poplatek za pronájem"
      },
      "bookedFrom": {
        "default": "Booking from",
        "value": "Objednávka od"
      },
      "bookedTo": {
        "default": "to",
        "value": "do"
      },
      "bookingDetails": {
        "default": "Bookingdetails",
        "value": "Detail objednávky"
      },
      "vatIncluded": {
        "default": "Incl. VAT.",
        "value": "včetně DHP."
      },
      "voucher": {
        "default": "Voucher",
        "value": "Poukaz"
      }, 
      "addVoucher": {
        "default": "Add Voucher",
        "value": "Přidat poukaz"
      },       
      "bookAs": {
        "default": "Book as",
        "value": "Objednat jako"
      },
      "bookFirmly": {
        "default": "Book bindingly",
        "value": "Závazně objednat"
      },
      "temporaryReservationUntil": {
        "default": "Temporäre Reservation, gültig bis",
        "value": "Dočasná rezervace, platná do"
      },
      "acceptAGB": {
        "default": "I accept the",
        "value": "Přijímám "
      },
      "agb": {
        "default": "General terms and conditions",
        "value": "Všeobecné obchodní podmínky"
      },
      "back": {
        "default": "Back",
        "value": "Zpět"
      },
      "next": {
        "default": "Next",
        "value": "Dále"
      },
      "nextTitle": {
        "default": "Všechna povinná pole musí být vyplněna a přijaty smluvní podmínky.",
        "value": "Všechna povinná pole musí být vyplněna a přijaty smluvní podmínky."
      }        
    },
    "bw02Services": {
      "next": {
        "default": "Next",
        "value": "Dále"
      },
      "services": {
        "default": "Services",
        "value": "Služby"
      },
      "back": {
        "default": "Back",
        "value": "Zpět"
      }
    },
    "objectDetail": {
      "back": {
        "default": "Back",
        "value": "Zpět"
      },
      "fromPrice": {
        "default": "Starting at",
        "value": "Od"
      },
      "bookObject": {
        "default": "Book objects",
        "value": "Objednat objekty"
      },
      "properties": {
        "default": "Features",
        "value": "Popis"
      },
      "notBookableOnline": {
        "default": "Dieses Objekt kann nicht online gebucht werden. Bitte kontaktieren Sie den Vermieter um dieses Objekt zu buchen.",
        "value": "Tento objekt nelze objednat online. Pro objednávku prosím kontaktujte pronajímatele."
      },      
      "showMoreProperties": {
        "default": "Show more features",
        "value": "Zobrazit celý popis"
      },
      "showLessProperties": {
        "default": "Close",
        "value": "Zavřít"
      },
      "attachments": {
        "default": "Attachments",
        "value": "Přílohy"
      },
      "unnamedAttachment": {
        "default": "Attachment",
        "value": "Příloha"
      },
      "showMoreAttachments": {
        "default": "Show more attachements",
        "value": "Zobrazit všechny přílohy"
      },
      "showLessAttachments": {
        "default": "Close",
        "value": "Zavřít"
      },
      "availableDates": {
        "default": "Available dates",
        "value": "Dostupná data"
      },
      "availableDatesDescription": {
        "default": "If necessary, change booking dates in the next step.",
        "value": "Termín objednávky můžete upravit v dalším kroku."
      },
      "weekView": {
        "default": "Week view",
        "value": "Týdenní náhled"
      },
      "monthView": {
        "default": "Month view",
        "value": "Měsíční náhled"
      },
      "yourChoice": {
        "default": "Your selection",
        "value": "Váš výběr"
      },
      "notAvailable": {
        "default": "Not available",
        "value": "Není k dispozici"
      },
      "pickupDrop": {
        "default": "Pickup and return times",
        "value": "Čas převzetí a vrácení"
      },
      "offers": {
        "default": "Offers",
        "value": "Nabídky"
      },
      "consumables": {
        "default": "Consumables",
        "value": "Spotřeba"
      },
      "services": {
        "default": "Services",
        "value": "Služby"
      },
      "accessories": {
        "default": "Accessories",
        "value": "Příslušenství"
      },
      "cancellationFees": {
        "default": "Cancellation fees",
        "value": "Storno poplatky"
      },
      "seasonDatetimes": {
        "default": "Saisonzeiten",
        "value": "Sezóny"
      },
      "pickups": {
        "default": "Übernahme",
        "value": "Převzetí"
      },
      "dropoffs": {
        "default": "Rückgabe",
        "value": "Vrácení"
      },
      "prolongation": {
        "default": "Verlängerung",
        "value": "Prodloužení"
      },        
      "description": {
        "default": "Description",
        "value": "Popis"
      }, 
      "noOfferItems": {
        "default": "There are no offers.",
        "value": "Žádná nabídka"
      },
      "showMoreOffers": {
        "default": "Show more offers",
        "value": "Zobrazit více nabídek"
      },
      "showLessOffers": {
        "default": "Close",
        "value": "Zavřít"
      },
      "noConsumables": {
        "default": "There are no consumables.",
        "value": "Žádné údaje o spotřebě"
      },
      "consumablesTabDescription": {
        "default": "Included consumables",
        "value": "Zahrnutá spotřeba"
      },
      "showMoreConsumables": {
        "default": "Show more consumables",
        "value": "Zobrazit více spotřebních poplatků"
      },
      "showLessConsumables": {
        "default": "Close",
        "value": "Zavřít"
      },
      "consumableMinimum": {
        "default": "At least",
        "value": "Alespoň"
      },       
      "consumableFooterDescription": {
        "default": "pro zusätzliche(n)",
        "value": "za dodatečné"
      }, 
      "noServices": {
        "default": "There are no services.",
        "value": "Žádné služby"
      },
      "discount": {
        "default": "Discount",
        "value": "Sleva"
      },
      "showMoreServices": {
        "default": "Show more services",
        "value": "Zobrazit více služeb"
      },
      "showLessServices": {
        "default": "Close",
        "value": "Zavřít"
      },
      "noAccessories": {
        "default": "There are no accessories.",
        "value": "Žádné příslušenství"
      },
      "showMoreAccessories": {
        "default": "Show more accessories",
        "value": "Zobrazit víc příslušenství"
      },
      "showLessAccessories": {
        "default": "Close",
        "value": "Zavřít"
      },
      "noCancellationFees": {
        "default": "No cancellation fees",
        "value": "Žádné storno poplatky"
      },
      "daysToPickup": {
        "default": "Days until pickup",
        "value": "Dnů do převzetí nebo dříve"
      },
      "hoursToPickup": {
        "default": "Hours until pickup",
        "value": "Hodiny do převzetí nebo dříve"
      },      
      "percent": {
        "default": "Percent",
        "value": "Procent"
      },
      "fix": {
        "default": "Fix",
        "value": "Pevná cena"
      },
      "showMoreCancellationFees": {
        "default": "Show more fees",
        "value": "Zobrazit více storno poplatků"
      },
      "showLessCancellationFees": {
        "default": "Close",
        "value": "Zavřít"
      }
    },
    "home": {
      "location": {
        "default": "Location",
        "value": "Pobočka"
      },
      "allLocationsSelected": {
        "default": "All locations",
        "value": "Všechny pobočky"
      },
      "selectAllLocations": {
        "default": "All locations",
        "value": "Všechny pobočky"
      },
      "noItemsLoadedYet": {
        "default": "No items loaded yet.",
        "value": "Žádné objekty nenačteny."
      },
      "objectType": {
        "default": "Object type",
        "value": "Typ objektu"
      },
      "allCategoriesSelected": {
        "default": "All categories",
        "value": "Všechny kategorie"
      },
      "selectAllCategories": {
        "default": "All categories.",
        "value": "Všechny kategorie"
      },
      "startDate": {
        "default": "Start date *",
        "value": "Začátek *"
      },
      "noStartDateSelected": {
        "default": "No start date selected.",
        "value": "Nevybráno žádné datum zahájení."
      },
      "duration": {
        "default": "Duration *",
        "value": "Trvání *"
      },
      "to": {
        "default": "to",
        "value": "do"
      },
      "count": {
        "default": "Number",
        "value": "Počet"
      },
      "enterUnitsCount": {
        "default": "Enter units count",
        "value": "Zadejte počet jednotek"
      },
      "timeUnit": {
        "default": "Time unit",
        "value": "Jednotka času"
      },
      "enterUnitsType": {
        "default": "Enter units type",
        "value": "Zadejte jednotku času"
      },
      "search": {
        "default": "Search",
        "value": "Hledat"
      },
      "priceFrom": {
        "default": "From",
        "value": "Od"
      }
    },
    "userBookingDetail": {
      "cancelBookingMessage": {
        "default": "You are going to cancel this booking. Are you sure?",
        "value": "Opravdu chcete zrušit tuto objednávku?" 
      },      
      "enthalteneMwst": {
        "default": "Enthaltene MwSt (${vatPercentage}%)",
        "value": "Zahrnutá DPH (${vatPercentage}%)"
      },
      "stornoGebuhren": {
        "default": "Storno-Gebühren",
        "value": "Storno poplatky"
      },
      "daysToPickup": {
        "default": "Tage bis zur Übernahme, oder früher",
        "value": "Dnů do převzetí nebo dříve"
      },
      "hoursToPickup": {
        "default": "Stunden bis zur Übernahme, oder früher",
        "value": "Hodiny do převzetí nebo dříve"
      },      
      "gesamtbetragFallig": {
        "default": "Gesamtbetrag, fällig",
        "value": "Celková suma, splatná"
      },
      "anzahlungFallig": {
        "default": "Anzahlung, fällig",
        "value": "Záloha, splatná"
      },
      "back": {
        "default": "Returned",
        "value": "Zpět"
      },
      "performPrint": {
        "default": "Print",
        "value": "Tisk"
      },
      "performCancel": {
        "default": "Cancel",
        "value": "Stornovat"
      },
      "mietbetrag": {
        "default": "Rental fee",
        "value": "Poplatek za pronájem"
      },
      "vatIncluded": {
        "default": "Incl. VAT.",
        "value": "včetně DPH"
      },      
      "bookedFrom": {
        "default": "Booking from",
        "value": "Objednávka od"
      },
      "bookedTo": {
        "default": "to",
        "value": "do"
      },
      "bookingNumber": {
        "default": "Booking-No.",
        "value": "Objednávka č."
      },
      "bookingState": {
        "default": "Status",
        "value": "Stav"
      },
      "bookingSaldo": {
        "default": "Balance",
        "value": "Bilance"
      },
      "objectAndAccessories": {
        "default": "Rental object and accessories",
        "value": "Objekt k pronájmu a příslušenství"
      },
      "description": {
        "default": "Description",
        "value": "Popis"
      },
      "count": {
        "default": "Qty.",
        "value": "Množství"
      },
      "offer": {
        "default": "Offer",
        "value": "Nabídka"
      },
      "season": {
        "default": "Season",
        "value": "Sezóna"
      },
      "deposit": {
        "default": "Kaution",
        "value": "Kauce"
      },        
      "price": {
        "default": "Price",
        "value": "Cena"
      },
      "subTotal": {
        "default": "Subtotal",
        "value": "Mezisoučet"
      },
      "conditionalServices": {
        "default": "Conditional fees",
        "value": "Podmíněné poplatky"
      },
      "article": {
        "default": "Article",
        "value": "Položka"
      },
      "subtotal": {
        "default": "Subtotal",
        "value": "Mezisoučet"
      },
      "services": {
        "default": "Services",
        "value": "Služby"
      },
      "discount": {
        "default": "Discount",
        "value": "Sleva"
      },
      "totalDiscount": {
        "default": "Total Discount",
        "value": "Celková sleva"
      },      
      "consumables": {
        "default": "Consumables",
        "value": "Spotřeba"
      },
      "consumableName": {
        "default": "Description",
        "value": "Popis"
      },
      "unit": {
        "default": "Unit",
        "value": "Jednotka"
      },
      "minIncl": {
        "default": "Min. / Incl.",
        "value": "Min. / Včetně"
      },
      "pricePerUnit": {
        "default": "Price / Unit",
        "value": "Cena za jednotku"
      },
      "extras": {
        "default": "Extras",
        "value": "Extra položky"
      },
      "priceShiftName": {
        "default": "Charge / Discount",
        "value": "Příplatek / Sleva"
      },
      "percent": {
        "default": "Percent",
        "value": "Procent"
      },
      "fix": {
        "default": "Fix",
        "value": "Pevná cena"
      },
      "bookingTotalPrice": {
        "default": "Grand total",
        "value": "Celková suma"
      },
      "billingAmount": {
        "default": "Invoice amount",
        "value": "Účtovaná suma"
      },
      "receivedPayments": {
        "default": "Received payments",
        "value": "Přijaté platby"
      }
    },
    "userBookings": {
      "archivedBookings": {
        "default": "Archived bookings",
        "value": "Archivované objednávky"
      },
      "activeBookings": {
        "default": "Active bookings",
        "value": "Aktivní objednávky"
      },
      "myBookings": {
        "default": "My bookings",
        "value": "Moje objednávky"
      },
      "noBookingsYet": {
        "default": "No bookings yet.",
        "value": "Dosud žádné objednávky"
      },
      "number": {
        "default": "Number",
        "value": "Číslo"
      },
      "object": {
        "default": "Rental object",
        "value": "Objekt k pronájmu"
      },
      "start": {
        "default": "Start",
        "value": "Začátek"
      },
      "end": {
        "default": "End",
        "value": "Konec"
      },
      "price": {
        "default": "Price",
        "value": "Cena"
      },
      "state": {
        "default": "Status",
        "value": "Stav"
      },
      "loadMore": {
        "default": "Load more",
        "value": "Načíst další"
      }
    },
    "search": {
      "location": {
        "default": "Location",
        "value": "Pobočka"
      },
      "allLocations": {
        "default": "All locations",
        "value": "Všechny pobočky"
      },
      "chooseAllLocations": {
        "default": "All locations",
        "value": "Všechny pobočky"
      },
      "noItemsLoadedYet": {
        "default": "No items loaded yet.",
        "value": "Žádné objekty nenačteny."
      },
      "objectType": {
        "default": "Object type",
        "value": "Typ objektu"
      },
      "allCategories": {
        "default": "All categories",
        "value": "Všechny kategorie"
      },
      "chooseAllCategories": {
        "default": "All categories",
        "value": "Všechny kategorie"
      },
      "startDate": {
        "default": "Start date",
        "value": "Začátek"
      },
      "noStartDateSelected": {
        "default": "No start date selected",
        "value": "Nevybráno žádné datum zahájení"
      },
      "diration": {
        "default": "Duration",
        "value": "Trvání"
      },
      "to": {
        "default": "to",
        "value": "do"
      },
      "count": {
        "default": "Qty.",
        "value": "Množství"
      },
      "enterUnitsCount": {
        "default": "Enter units count",
        "value": "Zadejte počet jednotek"
      },
      "timeUnit": {
        "default": "Time unit",
        "value": "Jednotka času"
      },
      "enterUnitsType": {
        "default": "Enter units type",
        "value": "Zadejte typ jednotky"
      },
      "properties": {
        "default": "Features",
        "value": "Vlastnosti"
      },
      "doNotCare": {
        "default": "Don't care",
        "value": "Nevybráno"
      },
      "thereAreNoResults": {
        "default": "There were no results for your search.",
        "value": "Nebyly nalezeny žádné výsledky odpovídající Vašemu zadání."
      },
      "fromPrice": {
        "default": "Starting at",
        "value": "Od"
      },
      "loadMore": {
        "default": "Load more",
        "value": "Načíst další"
      },
      "resetParameters": {
        "default": "Reset All",
        "value": "Vymazat vše"
      },
      "showAll": {
        "default": "Show All",
        "value": "Zobrazit vše"
      }         
    },
    "userProfile": {
      "street": {
        "default": "Street, Nr. *",
        "value": "Ulice, č. *"
      },      
      "addressAddition": {
        "default": "Address suffix",
        "value": "Doplnění adresy"
      },
      "postNumber": {
        "default": "ZIP *",
        "value": "PSČ *"
      },
      "place": {
        "default": "Place *",
        "value": "Obec *"
      },
      "country": {
        "default": "Country *",
        "value": "Stát *"
      },
      "registrationTitle": {
        "default": "Sign up",
        "value": "Zaregistrovat"
      },
      "profileTitle": {
        "default": "Hello",
        "value": "Ahoj ${firstName}"
      },      
      "registrationSubtitle": {
        "default": "Sign up for wy.by.",
        "value": "Zaregistrovat na wy.by"
      },
      "profileSubtitle": {
        "default": "Edit your user profile.",
        "value": "Upravit profil"
      },
      "customerInformation": {
        "default": "Customer information",
        "value": "Informace o zákazníkovi"
      },      
      "salutation": {
        "default": "Salutation *",
        "value": "Oslovení *"
      },
      "firstName": {
        "default": "First name *",
        "value": "Křestní jméno *"
      },
      "lastName": {
        "default": "Family name *",
        "value": "Příjmení *"
      },
      "organization": {
        "default": "Organization",
        "value": "Organizace"
      },      
      "email": {
        "default": "Email *",
        "value": "Email *"
      },
      "phone": {
        "default": "Phone",
        "value": "Telefon"
      },
      "mobilePhone": {
        "default": "Cellphone *",
        "value": "Mobilní telefon *"
      },
      "timeZone": {
        "default": "Timezone",
        "value": "Časové pásmo"
      },
      "language": {
        "default": "Corresponce language",
        "value": "Korespondenční jazyk"
      },
      "postalAddress": {
        "default": "Postal Address",
        "value": "Poštovní adresa"
      },
      "billingAddress": {
        "default": "Billing Address",
        "value": "fakturační adresa"
      }, 
      "useDifferentBillingAddress": {
        "default": "Different billing address",
        "value": "Odlišná fakturační adresa"
      },
      "password": {
        "default": "Password",
        "value": "Heslo"
      },
      "userNameReadOnly": {
        "default": "Username",
        "value": "Uživatelské jméno"
      },
      "userNameEditable": {
        "default": "Username *",
        "value": "Uživatelské jméno *"
      },
      "oldPassword": {
        "default": "Old password",
        "value": "Staré heslo"
      },
      "newPassword1": {
        "default": "New password *",
        "value": "Nové heslo *"
      },
      "newPassword2": {
        "default": "Confirm password *",
        "value": "Potvrďte heslo *"
      },
      "acceptAgb": {
        "default": "I accept the ",
        "value": "Přijímám "
      },
      "agb": {
        "default": "General terms & conditions",
        "value": "Všeobecné obchodní podmínky"
      },
      "back": {
        "default": "Cancel",
        "value": "Zrušit"
      },
      "registrationSave": {
        "default": "Save",
        "value": "Uložit"
      },
      "profileSave": {
        "default": "Save",
        "value": "Uložit"
      },
      "registrationStep2Title": {
        "default": "Registration",
        "value": "Registrace"
      },
      "registrationStep2Subtitle": {
        "default": "Thank you very much for your registration.",
        "value": "Děkujeme Vám za Vaši registraci."
      },
      "registrationStep2Text": {
        "default": "Please follow a link in your email to activate the account.",
        "value": "Prosím následujte odkaz v emailu a aktivujte svůj profil."
      },
      "registrationStep2GoHome": {
        "default": "Go to homepage",
        "value": "Zpět na úvodní stránku"
      },
      "registrationStep4Title": {
        "default": "Registration",
        "value": "Registrace"
      },
      "registrationStep4Subtitle": {
        "default": "You have registered successfully.",
        "value": "Úspěšně jste se zaregistrovali."
      },
      "registrationStep4GoHome": {
        "default": "Go to homepage",
        "value": "Zpět na úvodní stránku"
      }
    },
    "authentication": {
      "loggedOutDueToInactivity": {
        "default": "You were logged out because of inactivity.",
        "value": "Z důvodu nečinnosti jste byli odhlášeni.",
      }
    },
    "forgottenPassword": {
      "resetPassword": {
        "default": "Reset password",
        "value": "Obnovit heslo",
      },
      "enterEmailAddress": {
        "default": "Please enter the e-mail addresses you used for registration.",
        "value": "Zadejte prosím e-mailové adresy, které jste použili pro registraci.",
      }, 
      "yourEmailAddress": {
        "default": "Your e-mail address",
        "value": "Vaše emailová adresa",
      }, 
      "cancel": {
        "default": "Cancel",
        "value": "Zušit",
      },   
      "sendEmail": {
        "default": "Send e-mail",
        "value": "Poslat e-mailem",
      }, 
      "forgotPasswordEmail": {
        "default": "Forgotten password e-mail",
        "value": "E-mail pro obnovení hesla",
      }, 
      "weHaveSentEmail": {
        "default": "We have sent an email with a password recovery link to ${email}. Please open the email and click on the password recovery link.",
        "value": "Poslali jsme Vám e-mail s odkazem na obnovení hesla na ${email}. Prosím otevřete e-mail a klikněte na odkaz.",
      },  
      "Home": {
        "default": "Homepage",
        "value": "Domů",
      },
      "enterNewPassword": {
        "default": "Enter your new password and confirm it.",
        "value": "Zadejte nové heslo a potvrďte jej.",
      },   
      "username": {
        "default": "Username",
        "value": "Uživatelské jméno",
      }, 
      "newPassword": {
        "default": "New password",
        "value": "Nové heslo",
      },  
      "repeatNewPassword": {
        "default": "Repeat new password",
        "value": "Zopakujte nové heslo",
      },  
      "passwordComplexityDesc": {
        "default": "The password must be minimum 7 characters with at least one lowercase character and one special character.",
        "value": "Heslo musí mít minimálně 7 znaků s alespoň jedním malým písmenem a jedním speciálním znakem.",
      },
      "save": {
        "default": "Save",
        "value": "Uložit",
      }, 
      "resetSuccessTitle": {
        "default": "Password successfully reset",
        "value": "Heslo bylo úspěšně obnoveno",
      },   
      "resetSuccessDesc": {
        "default": "Your password was successfully reset. Please go to the start page and log in.",
        "value": "Vaše heslo bylo úspěšně obnoveno. Vraťte se prosím na úvodní stránku a přihlašte se.",
      },                                                                           
    }     
  },
  "unbound": {}
}


// WEBPACK FOOTER //
// ./src/translate/resources/csCZ.js